import i18n from '@/i18n'

export default [
  {
    path: '',
    component: { render (createElement) { return createElement('router-view') } },
    meta: {
      noContextRequired: true,
      permissions: ['Portal.Tickets.Read.Internal'],
      menu: {
        index: 100,
        activeWhen: ['ticketsOverview', 'ticketsDetail', 'addTicket'],
        title: i18n.t('label.support'),
        icon: ['fal', 'question-circle']
      }
    },
    children: [ {
      path: 'tickets',
      name: 'ticketsOverview',
      component: () => import(/* webpackChunkName: "ticket" */ '@/views/Tickets/Overview/TicketsOverview.vue'),
      meta: {
        menu: {
          routeName: 'ticketsOverview',
          activeWhen: ['ticketsOverview', 'ticketsDetail', 'addTicket'],
          title: i18n.t('label.tickets')
        }
      }
    }, {
      path: 'tickets/add',
      name: 'addTicket',
      component: () => import(/* webpackChunkName: "ticket" */ '@/views/Tickets/Detail/Forms/addTicketForm.vue'),
      props: () => ({ ticketId: null }),
      meta: {
        permissions: ['Portal.Tickets.Create']
      }
    }, {
      path: 'tickets/:ticketId',
      name: 'ticketsDetail',
      component: () => import(/* webpackChunkName: "ticket" */ '@/views/Tickets/Detail/TicketDetail.vue'),
      props: true
    }]
  }
]
